import { Component, HostListener } from '@angular/core';
import { Globals } from './common/globals';
import { CommonService } from './common/services/common.service';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  currentRoute: string | undefined;

  constructor(
    protected globals: Globals,
    private router: Router,
    protected commonService: CommonService
  ) { }
  title = 'chc-frontend';

  isCredentialRegistryPage(): boolean {
    return this.globals.currentLinkArr[1] == 'credential-registry';
  }

  isSignUpTandCPage(): boolean {
    return this.globals.currentLinkArr[2] == 'signup-terms-conditions';
  }

  isStorePublic(): boolean {
    return this.globals.currentLinkArr[1] == 'store' && !this.globals.currentLinkArr[2];
  }

  ngOnInit() {
    let [lastW, lastH] = [innerWidth, innerHeight],
      lock = false;

    addEventListener('resize', () => {
      const [w, h] = [innerWidth, innerHeight];
      if (!lock && w !== lastW && h !== lastH) {
        document
          .querySelectorAll('.k-animation-container')
          .forEach((el) => el.remove());
        // document.querySelector<HTMLElement>('.k-form-field')?.click();
        const firstField = document.querySelector<HTMLElement>('.default_lbl');
        if (firstField) {
          firstField.click();
          // console.log('Clicked first .k-form-field:', firstField);
        }
        [lastW, lastH] = [w, h];
        lock = true;
        setTimeout(() => (lock = false), 100);
      }
    });
  }
}
